import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
@Component({
  selector: 'app-create-tender',
  templateUrl: './create-tender.component.html',
  styleUrls: ['./create-tender.component.css']
})
export class CreateTenderComponent implements OnInit {
  customTimestamp = new Date().toISOString();
  userData = {
    FirstName: 'John',
    Emp_id: 101
  };

  addStoryForm = this.fb.group({
    StoryID: [''],
    Author: [this.userData.FirstName],
    oldDate: [''],
    tagInput: [''],
    StoryDate: [this.customTimestamp.slice(0, 16)],
    StoryHeading: ['', [Validators.required, Validators.maxLength(130)]],
    StorySubheading: ['', Validators.required],
    StorySynopsis: ['', [Validators.required, Validators.maxLength(50)]],
    storyDescription: [''],
    FullStory: ['', Validators.required],
    storyFile: [''],
    bigstory: [''],
    BreakingNews: [''],
    Slider: [''],
    HomePage: [''],
    tags: [''],
    videos: [''],
    mainImageAltText: ['', Validators.required],
    StoryImage1: [''],
    StoryImage2: [''],
    StoryImage3: [''],
    StoryImage4: [''],
    StoryImageThumb: [''],
    Active: [1],
    categoryBigstory: [''],
    ViewPoint: [''],
    offbeatnews: [''],
    catBigStory: [''],
    ImageCaption1: ['', Validators.required],
    ImageCaption2: [''],
    ImageCaption3: [''],
    ImageCaption4: [''],
    descreption: [''],
    Viewer: [''],
    authorID: [this.userData.Emp_id],
    category_id: ['', Validators.required],
    sub_category_id: [''],
    storyintro: [''],
    storyid_old: [''],
    indexnumber: [''],
    mainheading: [''],
    priority: [''],
    aceid: [''],
    url: [''],
    Old_Url: [''],
    state: ['', Validators.required],
    city: ['', Validators.required],
    exclusive: [''],
    bigstoryPriority: [''],
    storyMetaTitle: ['', [Validators.required, Validators.maxLength(130)]],
    storyMetaDescription: ['', [Validators.required, Validators.maxLength(210)]],
    userId: [this.userData.Emp_id],
    CreatedBy: [this.userData.Emp_id],
    UpdateBy: [this.userData.Emp_id],
    UpdatedDate: [this.customTimestamp.slice(0, 16)],
    mobileViewer: [''],
    photogalleryid: [''],
    internationalNews: [''],
    exclusiveNews: [''],
    homePage: [''],
    sendNotification: [''],
  });
  biddingForm!: FormGroup;
  selectionOptions = ['Pending', 'Selected', 'Rejected'];
  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
    this.biddingForm = this.fb.group({
      tenderDetails: this.fb.group({
        title: ['', Validators.required],
        referenceNo: ['', Validators.required],
        issueDate: ['', Validators.required],
        submissionDeadline: ['', Validators.required],
        document: [null]
      }),
      vendors: this.fb.array([])
    });
  }
  get vendors(): FormArray {
    return this.biddingForm.get('vendors') as FormArray;
  }

  addVendor(): void {
    this.vendors.push(this.fb.group({
      vendorName: ['', Validators.required],
      bidAmount: ['', [Validators.required, Validators.min(1)]],
      evaluationScore: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      status: ['Pending', Validators.required]
    }));
  }

  removeVendor(index: number): void {
    this.vendors.removeAt(index);
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.biddingForm.get('tenderDetails')?.get('document')?.setValue(file);
    }
  }

  submit(): void {
    if (this.biddingForm.valid) {
      console.log('Form Submitted:', this.biddingForm.value);
    } else {
      this.biddingForm.markAllAsTouched();
    }
  }

  onSubmit() {
    if (this.addStoryForm.valid) {
      const storyData = this.addStoryForm.value;
      console.log('Submitted data:', storyData);
      // submit logic
    }
  }


}